import React, { useMemo } from "react";
import { Row, Col } from 'reactstrap'

import CheckListProcessEntityTable from "../../../check_list/process/entity_table";
import { fetchCustomFieldValue, isAuthorizedCustomFieldToUser } from "../../../helper/custom_field/helper";

const LaboralCheckListHiringProcessEntityTable = props => {
  const {
    currentCustomer,
    currentUser,
    data,
    checkListEntities,
    callbacks:{
      callbackHandleProcessData
    },
    errors
  } = props;

  const {
    companies,
    customFields,
    securityLayers,
  } = data;

  const hiringStateOptions = [ {value: 'active', label: I18n.t('laboral.hirings.index.tabs.active') }, { value: 'expired', label: I18n.t('laboral.hirings.index.tabs.expired')}]

  const tableColumnSecurityLayer = useMemo(() => {
    if(currentCustomer.security_layer && securityLayers?.length > 0){
      return {
        field: 'employee.security_layer.name',
        header: I18n.t("activerecord.attributes.laboral/employee.security_layer_id"),
        body: (row) => row?.employee?.security_layer?.name || I18n.t('no_entry'),
        filter: {
          enabled: true,
          placeholder: 'Seleccione una capa de seguridad',
          inputType: 'simple_select',
          options: _.map(securityLayers, securityLayer => ({
            value: securityLayer.id,
            label: securityLayer.name,
          })),
          filterrific: {
            search: 'by_employee_security_layer_id'
          }
        }
      }
    }
  })

  const tableColumnsDefault = [
    {
      field: 'company.name',
      header: I18n.t('activerecord.attributes.laboral/hiring.company'),
      filter: {
        enabled: true,
        placeholder: 'Seleccione una empresa',
        inputType: 'simple_select',
        filterrific: {
          search: 'by_company',
        },
        options: _.map(companies, company => ({
          value: company.id,
          label: company.name,
        })),
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'company_name_'
        }
      },
    },
    {
      field: 'employee.identifier',
      header: I18n.t("activerecord.attributes.laboral/employee.identifier"),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el identificador del empleado',
        inputType: 'text',
        filterrific: {
          search: 'search_by_employee_identifier'
        }
      },
    },
    {
      field: 'employee.name',
      header: I18n.t("activerecord.attributes.laboral/employee.name"),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el nombre del empleado',
        inputType: 'text',
        filterrific: {
          search: 'search_by_name'
        }
      },
      sort: {
        enabled: true,
        filterrific: {
          sort: 'employee_name_'
        }
      },
    },
    {
      field: 'start_date_to_s',
      header: I18n.t("activerecord.attributes.laboral/hiring.start_date"),
      filter: {
        enabled: true,
        placeholder: 'Ingrese la fecha de inicio de la contratación',
        inputType: 'text',
        filterrific: {
          search: 'search_by_start_date'
        }
      },
    },
    {
      field: 'end_date_to_s',
      header: I18n.t("activerecord.attributes.laboral/hiring.end_date"),
      body: (row) => {
        return row?.end_date_to_s || 'Indefinido';
      },
      filter: {
        enabled: true,
        placeholder: 'Ingrese la fecha de fin de la contratación',
        inputType: 'text',
        filterrific: {
          search: 'search_by_end_date'
        }
      },
    },
    {
      field: 'active_to_s',
      header: 'Estado de Contratación',
      filter: {
        enabled: true,
        placeholder: 'Seleccione un estado de contratación',
        inputType: 'simple_select',
        options: hiringStateOptions,
        filterrific: {
          search: 'by_hiring_state'
        }
      },
    },
  ]

  const tableColumnsCustomFields = useMemo(() => {
    return _.map(customFields, function (customField) {
      return {
        field: `custom_fields.${ customField.code }`,
        header: _.capitalize(customField.label),
        body: (row) => {
          return fetchCustomFieldValue(customField, row.custom_fields[customField.code], currentUser)
        },
        filter: {
          enabled: true,
          placeholder: `Ingrese ${ _.capitalize(customField.label) }`,
          filterrific: {
            search: `search_by_key_custom_fields`,
            searchKey: customField.code
          }
        },
        configuration: {
          isCustomField: true
        }
      }
    })
  }, [])

  const tableColumns = useMemo(() => {
    let columns = _.concat(
      tableColumnSecurityLayer,
      tableColumnsDefault,
      tableColumnsCustomFields
    )

    return _.compact(columns)
  }, [])

  return(
    <Row>
      <Col md={12}>
        <CheckListProcessEntityTable
          checkListEntities={ checkListEntities }
          dataTableConfiguration={{
            columns: tableColumns
          }}
          configuration={{
            showDistributionListFilter: true,
            entityKey: 'hirings',
            defaultRequestParams: {},
            context: 'laboral'
          }}
          routes = {{
            indexEntitiesPath: Routes.laboral_hirings_path
          }}
          callbacks={{
            callbackHandleProcessData: callbackHandleProcessData
          }}
          errors={ errors }
        />
      </Col>
    </Row>
  )
}

export default LaboralCheckListHiringProcessEntityTable
